// src/components/salon-management/product-section/ProductCard.tsx
import React from "react";
import { SelectProduct } from "../../../types/salon.types";
import Image from "src/shared/Image";
import { useUserTheme } from "src/shared/hooks/useUserTheme";
import { useUser } from "src/shared/context/UserContext";
import { borderHighlightOptions } from "src/shared/modules/profile/theme/themeConstants";

interface ProductCardProps {
  product: SelectProduct;
  isSelected: boolean;
  onSelect: (product: SelectProduct) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, isSelected, onSelect }) => {
  const { user } = useUser();
  const themeKey = user?.themes.backgroundColour || "DodgerBlue";
  const highlightClass = borderHighlightOptions[themeKey];

  return (
    <div
      onClick={() => onSelect(product)}
      className={`
        rounded-lg transition-all duration-300 
        shadow-md hover:shadow-lg hover:-translate-y-1 
        border ${isSelected ? `${highlightClass} ring-2` : "border-gray-200 bg-gray-50"}
        h-full flex flex-col cursor-pointer overflow-hidden
      `}
    >
      <div className="p-3 flex flex-col flex-grow">
        {/* Product Image */}
        <div className="flex-shrink-0 mb-2 flex justify-center items-center h-[140px] overflow-hidden">
          <Image imagePath={product.imageUrl} className="w-full h-full object-contain" />
        </div>

        {/* Product Info */}
        <div className="flex-grow">
          <h3 className="text-sm font-medium text-gray-800 line-clamp-2 break-words">{product.productName}</h3>

          {product.arabicName && <p className="text-xs text-gray-500 line-clamp-2 break-words mt-1">{product.arabicName}</p>}
        </div>

        {/* Price */}
        <p className="text-sm font-bold text-blue-600 mt-2 text-right">{Number(product.amount).toFixed(2)} QAR</p>
      </div>
    </div>
  );
};

export default ProductCard;
